export const head = 'bg-green-400 normal-case text-gray-600';
export const headCell = 'py-3 px-6';
export const arrowIcons = 'flex';
export const bodyRow = 'bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600';
export const bodyCell = '';
export const emptyRow = 'h-64';
export const emptyCell = 'flex justify-center items-center h-full';